import { Grid } from '@mui/material';
import { WsInputNumber, WsSelect, WsSelectObj, WsTypography } from 'wisestep-base';

import { timeSpanOptions } from '../../../../../features/automatedEmailCampaignSettings/utils';

const DuretionInput = ({
  tagLine,
  durationName,
  timeSpanName,
  timeSpanOptionList = timeSpanOptions,
}: {
  tagLine: string;
  durationName: string;
  timeSpanName: string;
  timeSpanOptionList?: WsSelectObj[];
}) => (
  <Grid display="flex" direction="row" columnGap={1.5} alignItems="center">
    <Grid>
      <WsTypography>{tagLine}</WsTypography>
    </Grid>
    <Grid xs={2}>
      <WsInputNumber name={durationName} placeholder="" />
    </Grid>
    <Grid xs={2}>
      <WsSelect name={timeSpanName} selectArray={timeSpanOptionList} size="small" />
    </Grid>
  </Grid>
);

export default DuretionInput;
